import React, { useEffect, useState } from 'react';
import moment from 'moment';
import DeleteModal from '../../utils/deleteModal/deleteModal';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import AddUser from './AddUser';
import services from '../../services';
import { GET_ALL_USER } from '../../utils/Apifunction';
import { FiEdit, FiSearch, FiUsers, FiFilter } from 'react-icons/fi';
import PageHeader from '../../common/PageHeader';
import TablePagination from '../../common/TablePagination';
import { MdDeleteOutline, MdAdd } from 'react-icons/md';
import Select from "react-select";
import './User.css';
import { FaLocationDot } from "react-icons/fa6";
import { styles } from './UserTable.styles';
import { filterSelectStylesSm as filterSelectStyles } from '../../common/filterSelectStyles';

const userTypeOptions = [
    { value: "Driver", label: "Driver" },
    { value: "Tour Guide", label: "Tour Guide" },
    { value: "Accommodation", label: "Accommodation" },
    { value: "Restaurant", label: "Restaurant" },
    { value: "Flight", label: "Flight" },
    { value: "Transportation", label: "Transportation" },
    { value: "Attraction Ticket", label: "Attraction Ticket" },
    { value: "Rent-a-Car", label: "Rental" },
    { value: "Ferry", label: "Ferry" },
    { value: "Manager", label: "Manager" },
    { value: "Product Manager", label: "Product Manager" },
    { value: "Sales", label: "Sales" },
    { value: "Logistic Manager", label: "Logistic Manager" },
    { value: "Operations Manager", label: "Operations Manager" },
    { value: "Travel Agent", label: "Travel Agent" },
    { value: "Reservation Team", label: "Reservation Team" },
];


const UserTable = () => {
    const [userData, setUserData] = useState([]);
    const [editData, setEditData] = useState('');
    const [editId, setEditId] = useState('');
    const [showModalDelete, setShowModalDelete] = useState(false);
    const [selectDeleteId, setSelectDeleteId] = useState('');
    const [addUserStatus, setAddUserStatus] = useState(false);
    const [searchUserData, setSearchUserData] = useState('');
    const [sortProducts, setSortProducts] = useState({ key: 'createdAt', direction: 'desc' });
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const pageSize = 20;
    const [gmailUsers, setGmailUsers] = useState([]);
    const [selectedEmails, setSelectedEmails] = useState([]);
    const navigate = useNavigate();
    const [countryList, setCountryList] = useState([]);
    const [stateList, setStateList] = useState([]);
    const [cityList, setCityList] = useState([]);
    const [locationFilter, setLocationFilter] = useState({
        country: '',
        state: '',
        city: ''
    });
    const [filterUserType, setFilterUserType] = useState("");
    const [userGroup, setUserGroup] = useState("");
    const [appliedFilters, setAppliedFilters] = useState({
        country: '',
        state: '',
        city: '',
        userType: '',
        search: '',
        group: ''
    });
    const [loader, setloader] = useState(false);
    const [groupValues, setGroupValues] = useState([]);
    const [showFilter, setShowFilter] = useState(false);

    const activeFilterCount = [
        appliedFilters.country,
        appliedFilters.state,
        appliedFilters.city,
        appliedFilters.userType,
        appliedFilters.search,
        appliedFilters.group,
    ].filter(Boolean).length;
    const handleStatusToggle = async (item) => {
        try {
            await services.user.UPDATE_USER(item?.id, { status: !item?.status });
            toast.success(`${item?.name}'s status updated successfully!`);
            GET_ALL_USER_DATA();
        } catch (e) {
            toast.error('Failed to update status!');
            console.error(e);
        }
    };

    const handleEdit = (data) => {
        setEditData(data);
        setAddUserStatus(true);
        setEditId(data?.id);
    };

    const handleDelete = async () => {
        try {
            await services.user.DELETE_USER(selectDeleteId);
            toast.success('User deleted successfully!');
            GET_ALL_USER_DATA();
        } catch (e) {
            toast.error('Failed to delete user!');
            console.error(e);
        }
    };
    const getAllLinkedEmail = async () => {
        try {
            const response = await services.email.Get_The_Linked_Email();
            if (response) {
                const options = response?.data?.map((email) => ({
                    label: email.email,
                    value: email.id,
                    color: email.colour,
                }));
                setGmailUsers(options);
            }
        } catch (error) {
            console.error('error');
        }
    };
    const handleConfirm = () => {
        setShowModalDelete(false);
        handleDelete();
    };

    useEffect(() => {
        GET_ALL_USER_DATA();

    }, [appliedFilters, sortProducts, currentPage]);
    useEffect(() => {
        getAllLinkedEmail()

    }, [])
    const GET_ALL_USER_DATA = async () => {
        setloader(true)
        const object = {
            page: currentPage,
            search: appliedFilters.search,
            sortBy: sortProducts.key,
            sortOrder: sortProducts.direction,
            limit: pageSize,
            isPermission: true,
            isActive: true,
            country: appliedFilters.country,
            state: appliedFilters.state,
            city: appliedFilters.city,
            userType: appliedFilters.userType,
            groupId: appliedFilters.group
        };
        try {
            const response = await GET_ALL_USER(object);
            if (response) {
                setUserData(response?.users || []);
                setTotalPages(response?.totalPages || 1);
            }
        } catch (error) {
            console.log(error)
        } finally {
            setloader(false)
        }

    };

    function handleSort(key) {
        setSortProducts((prev) => {
            if (prev.key === key) {
                return { key, direction: prev.direction === 'asc' ? 'desc' : 'asc' };
            }
            return { key, direction: 'asc' };
        });
        setCurrentPage(1);
    }
    function renderSortIcon(key) {
        if (sortProducts.key !== key) return null;
        return sortProducts.direction === 'asc' ? ' ▲' : ' ▼';
    }
    const [selectedEmailsByUser, setSelectedEmailsByUser] = useState({});
    const handleArchivePermission = async (item) => {
        try {
            await services.user.UPDATE_USER(item?.id, { isPermission: !item?.isPermission });
            toast.success(`${item?.name}'s archive permission updated successfully!`);
            GET_ALL_USER_DATA();
        } catch (e) {
            toast.error('Failed to update archive permission!');
            console.error(e);
        }
    };

    const handleAssingUser = async (userId, selectedEmails) => {
        try {
            await services.user.UPDATE_USER(userId, {
                usersEmailMapped: selectedEmails ?? []
            });

            toast.success(`Archive permissions updated successfully!`);
            GET_ALL_USER_DATA();
        } catch (e) {
            toast.error('Failed to update archive permission!');
            console.error(e);
        }
    };
    const handleEmailChange = (userId, selected) => {
        setSelectedEmailsByUser(prev => ({
            ...prev,
            [userId]: selected || []
        }));

        handleAssingUser(userId, selected)
    };
    useEffect(() => {
        if (Array.isArray(userData)) {
            const mapped = {};
            userData.forEach(user => {
                mapped[user.id] = user.usersEmailMapped || [];
            });
            setSelectedEmailsByUser(mapped);
        }
    }, [userData]);

    const getCountryGoupList = async () => {
        try {
            const params = new URLSearchParams({
                falsePagination: true,
            }).toString();
            const response = await services.user.GET_ALL_INCLUSIONGROUP(
                "destinations",
                params
            );
            setCountryList(response?.data?.data);
        } catch (error) {
            console.error(error);
        }
    };

    const getGroup = async () => {
        try {
            const object = {
                falsePagination: true,
            };
            const data = new URLSearchParams(object);
            const response = await services.user.GET_GROUP(data);
            setGroupValues(response?.data?.data);
        } catch (error) {
            console.error("error", error);
        }
    };
    useEffect(() => {
        getCountryGoupList();
        getGroup()
    }, []);

    const fetchStateList = async (countryId) => {
        if (!countryId) {
            setStateList([]);
            return;
        }
        const params = new URLSearchParams({
            country: countryId,
            falsePagination: true,
        });
        try {
            const response = await services.user.GET_INCLUSION(
                "destinations",
                params
            );
            setStateList(response?.data?.data || []);
        } catch (err) {
            console.error(err);
        }
    };

    const fetchCityList = async (countryId, stateId) => {
        if (!countryId || !stateId) {
            setCityList([]);
            return;
        }
        const params = new URLSearchParams({
            country: countryId,
            state: stateId,
        });
        try {
            const response = await services.user.GET_CITY(params);
            setCityList(response?.data?.data || []);
        } catch (err) {
            console.error(err);
        }
    };

    const onLocationChange = (field, value) => {
        setLocationFilter(prev => {
            const updated = { ...prev, [field]: value };

            if (field === "country") {
                updated.state = "";
                updated.city = "";
                setCityList([]);
                fetchStateList(value);
            } else if (field === "state") {
                updated.city = "";
                fetchCityList(prev.country, value);
            }

            return updated;
        });
    };

    const handleApplyFilter = () => {
        setAppliedFilters({
            ...locationFilter,
            userType: filterUserType,
            search: searchUserData,
            group: userGroup
        });
        setCurrentPage(1);
    };

    const handleReset = () => {
        const initialLocation = { country: '', state: '', city: '' };
        setLocationFilter(initialLocation);
        setFilterUserType("");
        setSearchUserData("");
        setAppliedFilters({
            ...initialLocation,
            userType: '',
            search: '',
            group: ''
        });
        setUserGroup("");
        setCurrentPage(1);
    };
    return (
        <div style={styles.pageWrapper}>

            {/* ── Top Bar ── */}
            <PageHeader
                onBack={() => navigate('/app')}
                icon={<FiUsers size={17} color="#fff" />}
                title="User Management"
                count={userData.length > 0 ? `${(currentPage - 1) * pageSize + 1}–${Math.min(currentPage * pageSize, (currentPage - 1) * pageSize + userData.length)}` : '0'}
                rightContent={
                    <div style={styles.searchBar}>
                        <div style={styles.searchInputWrapper}>
                            <FiSearch size={14} style={styles.searchIcon} />
                            <input
                                type="text"
                                placeholder="Search by name or email..."
                                value={searchUserData}
                                onChange={(e) => setSearchUserData(e.target.value)}
                                onKeyDown={(e) => e.key === 'Enter' && handleApplyFilter()}
                                style={styles.searchInput}
                                onFocus={e => { e.currentTarget.style.borderColor = '#1a7d3e'; e.currentTarget.style.boxShadow = '0 0 0 3px rgba(26,125,62,0.12)'; }}
                                onBlur={e => { e.currentTarget.style.borderColor = '#e5e7eb'; e.currentTarget.style.boxShadow = 'none'; }}
                            />
                        </div>
                        <button
                            style={styles.btnSearch}
                            onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#1a6b2e'; }}
                            onMouseLeave={e => { e.currentTarget.style.backgroundColor = '#1a7d3e'; }}
                            onClick={handleApplyFilter}
                        >
                            Search
                        </button>
                        <button
                            style={{
                                ...styles.btnFilterToggle,
                                ...(showFilter ? styles.btnFilterToggleActive : {}),
                            }}
                            onMouseEnter={e => {
                                if (!showFilter) {
                                    e.currentTarget.style.backgroundColor = '#f0fdf4';
                                    e.currentTarget.style.borderColor = '#86efac';
                                }
                            }}
                            onMouseLeave={e => {
                                if (!showFilter) {
                                    e.currentTarget.style.backgroundColor = '#fff';
                                    e.currentTarget.style.borderColor = '#bbf7d0';
                                }
                            }}
                            onClick={() => setShowFilter(v => !v)}
                        >
                            <FiFilter size={14} />
                            Filters
                            {activeFilterCount > 0 && (
                                <span style={styles.filterBadge}>{activeFilterCount}</span>
                            )}
                        </button>
                    </div>
                }
            />

            {/* ── Filter Card (collapsible) ── */}
            {showFilter && (
                <div style={styles.filterCard}>
                    <div style={styles.filterGrid}>

                        {/* Location */}
                        <div style={styles.filterGroupWide}>
                            <label style={styles.filterLabel}>Location</label>
                            <div style={styles.locationRow}>
                                <Select
                                    styles={filterSelectStyles}
                                    isSearchable={false}
                                    options={[{ value: "", label: "All Countries" }, ...countryList.map(({ title, id }) => ({ value: String(id), label: title }))]}
                                    value={{ value: String(locationFilter.country || ""), label: countryList.find(c => String(c.id) === String(locationFilter.country))?.title || "All Countries" }}
                                    onChange={(opt) => onLocationChange("country", opt?.value || "")}
                                />
                                <Select
                                    styles={filterSelectStyles}
                                    isSearchable={false}
                                    options={[{ value: "", label: "All States" }, ...stateList.map(({ title, id }) => ({ value: String(id), label: title }))]}
                                    value={{ value: String(locationFilter.state || ""), label: stateList.find(s => String(s.id) === String(locationFilter.state))?.title || "All States" }}
                                    onChange={(opt) => onLocationChange("state", opt?.value || "")}
                                />
                                <Select
                                    styles={filterSelectStyles}
                                    isSearchable={false}
                                    options={[{ value: "", label: "All Cities" }, ...cityList.map(({ name, id }) => ({ value: String(id), label: name }))]}
                                    value={{ value: String(locationFilter.city || ""), label: cityList.find(c => String(c.id) === String(locationFilter.city))?.name || "All Cities" }}
                                    onChange={(opt) => onLocationChange("city", opt?.value || "")}
                                />
                            </div>
                        </div>

                        {/* User Type */}
                        <div style={styles.filterGroup}>
                            <label style={styles.filterLabel}>User Type</label>
                            <Select
                                styles={filterSelectStyles}
                                isSearchable={false}
                                options={[{ value: "", label: "All" }, ...userTypeOptions]}
                                value={{ value: filterUserType || "", label: userTypeOptions.find(t => t.value === filterUserType)?.label || "All" }}
                                onChange={(opt) => setFilterUserType(opt?.value || "")}
                            />
                        </div>

                        {/* User Group */}
                        <div style={styles.filterGroup}>
                            <label style={styles.filterLabel}>User Group</label>
                            <Select
                                styles={filterSelectStyles}
                                isSearchable={false}
                                options={[{ value: "", label: "All" }, ...groupValues.map(({ name, id }) => ({ value: String(id), label: name }))]}
                                value={{ value: String(userGroup || ""), label: groupValues.find(g => String(g.id) === String(userGroup))?.name || "All" }}
                                onChange={(opt) => setUserGroup(opt?.value || "")}
                            />
                        </div>

                        {/* Actions */}
                        <div style={styles.filterActions}>
                            <button
                                style={styles.btnFilter}
                                onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#1a6b2e'; }}
                                onMouseLeave={e => { e.currentTarget.style.backgroundColor = '#1a7d3e'; }}
                                onClick={handleApplyFilter}
                            >
                                Apply
                            </button>
                            <button
                                style={styles.btnReset}
                                onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#e9eaec'; }}
                                onMouseLeave={e => { e.currentTarget.style.backgroundColor = '#f3f4f6'; }}
                                onClick={handleReset}
                            >
                                Reset
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* ── Table Card ── */}
            <div style={styles.tableCard}>
                <div style={styles.tableScroll}>
                    <table style={styles.table}>
                        <thead>
                            <tr style={styles.theadRow}>
                                <th style={{ ...styles.th, width: '52px' }} onClick={() => handleSort('no')}>
                                    No.{renderSortIcon('no')}
                                </th>
                                <th style={styles.th} onClick={() => handleSort('name')}>
                                    User Name{renderSortIcon('name')}
                                </th>
                                <th style={styles.th} onClick={() => handleSort('email')}>
                                    Email{renderSortIcon('email')}
                                </th>
                                <th style={styles.th} onClick={() => handleSort('createdAt')}>
                                    Create Date{renderSortIcon('createdAt')}
                                </th>
                                <th style={styles.th} onClick={() => handleSort('userEmailMapped')}>
                                    Assign Email Inbox{renderSortIcon('userEmailMapped')}
                                </th>
                                <th style={{ ...styles.thNoSort, textAlign: 'center' }}>Actions</th>
                                <th style={{ ...styles.thNoSort, textAlign: 'center' }}>Archive Permission</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loader ? (
                                <tr>
                                    <td colSpan="7" style={styles.loaderCell}>
                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
                                            <div
                                                style={{
                                                    width: '32px', height: '32px', borderRadius: '50%',
                                                    border: '3px solid #dcfce7', borderTopColor: '#1a7d3e',
                                                    animation: 'spin 0.8s linear infinite',
                                                }}
                                            />
                                            <span style={{ fontSize: '13px', color: '#9ca3af' }}>Loading users…</span>
                                        </div>
                                    </td>
                                </tr>
                            ) : userData.length === 0 ? (
                                <tr>
                                    <td colSpan="7">
                                        <div style={styles.emptyState}>
                                            <FiUsers size={40} color="#d1d5db" />
                                            <p style={styles.emptyText}>No users found</p>
                                        </div>
                                    </td>
                                </tr>
                            ) : (
                                userData.map((item, index) => (
                                    <tr
                                        key={item.id}
                                        style={styles.row}
                                        onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#f6fdf8'; }}
                                        onMouseLeave={e => { e.currentTarget.style.backgroundColor = '#fff'; }}
                                    >
                                        <td style={styles.indexCell}>
                                            {(currentPage - 1) * pageSize + index + 1}
                                        </td>

                                        <td style={styles.td}>
                                            <div style={styles.nameCell}>
                                                <div style={styles.avatar}>
                                                    {(item?.name || '?').charAt(0).toUpperCase()}
                                                </div>
                                                <span style={styles.nameText}>{item?.name}</span>
                                            </div>
                                        </td>

                                        <td style={styles.td}>
                                            <span style={styles.emailChip}>{item?.email}</span>
                                        </td>

                                        <td style={styles.td}>
                                            <span style={styles.dateBadge}>
                                                {moment(item?.createdAt).format('DD MMM YYYY')}
                                            </span>
                                        </td>

                                        <td className="multi-select-box" style={{ ...styles.td, minWidth: '220px' }}>
                                            <Select
                                                isMulti
                                                options={gmailUsers}
                                                value={selectedEmailsByUser[item.id] || []}
                                                onChange={(val) => handleEmailChange(item.id, val)}
                                                placeholder="Select user"
                                                closeMenuOnSelect={true}
                                                hideSelectedOptions={false}
                                            />
                                        </td>

                                        <td style={{ ...styles.td, textAlign: 'center' }}>
                                            <div style={styles.actionGroup}>
                                                <button
                                                    style={styles.btnDelete}
                                                    title="Delete user"
                                                    onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#fee2e2'; }}
                                                    onMouseLeave={e => { e.currentTarget.style.backgroundColor = '#fff5f5'; }}
                                                    onClick={() => {
                                                        setShowModalDelete(true);
                                                        setSelectDeleteId(item.id);
                                                    }}
                                                >
                                                    <MdDeleteOutline fontSize={17} />
                                                </button>
                                                <button
                                                    style={styles.btnAdd}
                                                    title="Assign board"
                                                    onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#dcfce7'; }}
                                                    onMouseLeave={e => { e.currentTarget.style.backgroundColor = '#f0fdf4'; }}
                                                    onClick={() => navigate('/assignboard', { state: item })}
                                                >
                                                    <MdAdd fontSize={17} />
                                                </button>
                                            </div>
                                        </td>

                                        <td style={{ ...styles.td, textAlign: 'center' }}>
                                            <div className="form-check form-switch" style={{ display: 'flex', justifyContent: 'center', margin: 0 }}>
                                                <input
                                                    className="form-check-input"
                                                    style={{ height: '20px', width: '36px', cursor: 'pointer', accentColor: '#1a7d3e' }}
                                                    type="checkbox"
                                                    checked={item.isPermission}
                                                    onChange={() => handleArchivePermission(item)}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* ── Pagination ── */}
            <div style={{ marginTop: '20px' }}>
                <TablePagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPrev={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                    onNext={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                />
            </div>

            {showModalDelete && (
                <DeleteModal
                    handleCloseModal={() => setShowModalDelete(false)}
                    handleConfirm={handleConfirm}
                    showModal={showModalDelete}
                    confirmButtonName="Delete"
                />
            )}
            {addUserStatus && (
                <AddUser
                    showModal={addUserStatus}
                    handleClose={() => setAddUserStatus(false)}
                    editData={editData}
                    GET_ALL_USER={GET_ALL_USER_DATA}
                    editId={editId}
                />
            )}
        </div>
    );
};

export default UserTable;
